module.exports = {
  
  //API_LOCATION: 'https://iteam.org.ua/apiweb/dev_api.php'
  API_LOCATION: 'https://webdev.iteam.org.ua/apiweb/dev_api2.php'
   //API_LOCATION: 'https://webdev.iteam.org.ua/apiweb/dev_api.php'  
}